// @flow

import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 20px;
  box-sizing: border-box;
`;
